import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    changeKeySignature: {
        id: "score.changeKeySignature",
    },
    modify: {
        id: "general.modify",
    },
    modulation: {
        id: "score.modulation.label",
    },
    direction: {
        id: "score.modulation.direction.label",
    },
    up: {
        id: "score.modulation.direction.up",
    },
    down: {
        id: "score.modulation.direction.down",
    },
    removeKeyChange: {
        id: "score.modulation.remove",
    }
});

export default messages;
